import React, { useState } from 'react';
import SamanKishTokenForm from '../SamanKishTokenForm/SamanKishTokenForm';
import { Backdrop, Button, Stack } from '@mui/material';
import FrameCard from '../FrameCard/FrameCard';
import { Price3DigitSplitter } from 'utils/Price3DigitSplitter';
import PaymentPortals from 'Routes/Public/GetNewTurn/Components/PaymentPortals/PaymentPortals';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { useAtom } from 'jotai';
import { selectedPortal } from 'Routes/Public/GetNewTurn/shared/selected.portal';
import { PayByZarinPal } from 'Routes/Public/GetNewTurn/adapaters/PayByZarinPal';
import Cookies from 'js-cookie';
import { GetSamanKishToken } from 'Routes/Public/GetNewTurn/adapaters/GetSamanKishToken';
import useCheckActivatedPaymentGateways from 'Global/Hooks/useCheckActivatedPaymentGateways/useCheckActivatedPaymentGateways';

const GeneralPaymentBackdrop = ({
  openBackdrop,
  priceTag,
  setBackdrop,
  labels,
  // "labels is an object and must containt this labels. you can just copy the values to the FindLangKey(), eg.. FindLangKey(select_portal_label)"
  // price: price,
  // selectPortal: select_portal_label,
  // Zarin_pal_label: Zarin_pal_label,
  // Saman_kish_label: Saman_kish_label,
  // backwardMsg: backwardMsg,
  // continueMsg: continueMsg,
}) => {
  const [samanToken, setSamanToken] = useState('');
  const [portal] = useAtom(selectedPortal);
  const user = JSON.parse(Cookies.get('user'));
  const idPatient = JSON.parse(
    Cookies.get('user')
  )?.IdPatient;

  let currentUrl = window.location.href;
  currentUrl = document.URL;
  currentUrl = new URL(window.location);
  currentUrl = currentUrl.origin;

  const gateways = useCheckActivatedPaymentGateways();

  const isSamanKishEnabled =
    typeof gateways !== 'string' &&
    gateways &&
    gateways?.findIndex((item) => item.Id === 2) !== -1;

  const isZarinPalEnabled =
    typeof gateways !== 'string' &&
    gateways &&
    gateways?.findIndex((item) => item.Id === 1) !== -1;

  return (
    <React.Fragment>
      <React.Fragment>
        {isSamanKishEnabled ? (
          <SamanKishTokenForm token={samanToken} />
        ) : (
          <></>
        )}
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={openBackdrop}
          // onClick={() => {
          //   setBackdrop(false);
          // }}
        >
          <FrameCard
            cardProps={{
              p: '.4em',
              borderRadius: '20px',
              width: '22em !important',
              minWidth: '22em !important',
            }}
            jsx={
              <div
                style={{
                  backgroundColor: 'white',
                  width: '22em !important',
                  minWidth: '22em !important',
                  padding: '.5em',
                  borderRadius: '20px',
                  paddingBlock: '1em',
                }}
              >
                <p
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    width: '100%',
                    alignItems: 'center',
                    minHeight: '40px',
                    borderRadius: '.3em',
                    fontWeight: 'bolder',
                    fontSize: '1.2em',
                    border: '1px solid gray',
                    marginBottom: '.5em',
                  }}
                >
                  {labels.price} 
                  {Price3DigitSplitter(priceTag)}
                   ریال 
                </p>

                <PaymentPortals
                  label={labels.select_portal_label}
                  ZpLabel={labels.Zarin_pal_label}
                  SmLabel={labels.Saman_kish_label}
                />

                <Stack mt="1em" direction="row" gap=".5em">
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      color: `${themeColors.ColorPrimary} !important`,
                    }}
                    onClick={() => {
                      setBackdrop(false);
                    }}
                  >
                    {labels.backwardMsg}
                  </Button>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      color: `${themeColors.ColorPrimary} !important`,
                    }}
                    onClick={() => {
                      localStorage.setItem(
                        'general_payment',
                        JSON.stringify(true)
                      );
                      if (
                        portal === 'zp' &&
                        isZarinPalEnabled
                      ) {
                        PayByZarinPal({
                          idPatient: idPatient,
                          amount: priceTag,
                          Description: `افزایش موجودی`,
                          email: user.Email,
                          mobile: user.Mobile,
                          callBackLink: `${currentUrl}/VerifyZarinPal`,
                        });
                        return;
                      }
                      if (
                        portal === 'sm' &&
                        isSamanKishEnabled
                      ) {
                        GetSamanKishToken(setSamanToken, {
                          amount: priceTag,
                          mobile: user.Mobile,
                        });
                      }
                    }}
                  >
                    {labels.continueMsg}
                  </Button>
                </Stack>
              </div>
            }
          />
        </Backdrop>
      </React.Fragment>
    </React.Fragment>
  );
};

export default GeneralPaymentBackdrop;
